export const SORT_KEY_VEHICLE_NAME = 'name';
export const SORT_KEY_CHARGING_STATUS = 'chargingStatus';
export const SORT_KEY_STATE_OF_CHARGE = 'stateOfCharge';
export const SORT_KEY_REMAINING_RANGE = 'remainingRange';
export const SORT_KEY_READY_TO_DRIVE = 'readyToDriveStatus';
export const SORT_KEY_LAST_UPDATED = 'timestamp';
